import Alpine from "alpinejs";

export default function ScrollSpy() {
  const faqSinglePage = document.querySelector('.faq-contents');

  if (!faqSinglePage) {
    const tableOfContents = document.getElementById('faq-toc');
    const tableOfContents__Nav = document.querySelector('.scrollspy__menu');
    const tableOfContents__NavIcon = document.querySelector('.scrollspy__arrowicon');
    const menuItems = document.querySelectorAll(".scrollspy__menu a"); //use .scrollspy__menu for parent element of list menu
    const section = document.querySelectorAll(".scrollspy__item"); // use .scrollspy__item for each relevant section
    const activeClasses = [
      "border-l-theme-blue",
      "!text-theme-blue",
      "font-medium",
    ]; // the class list of active class as array
    let sections = {};
    let i = 0;
  
    function openDropdown() {
      if (window.innerWidth < 1024) tableOfContents__Nav.style.maxHeight = `${tableOfContents__Nav.scrollHeight}px`
      tableOfContents__NavIcon.style.setProperty('--tw-rotate', '180deg');
    }
  
    function closeDropdown() {
      if (window.innerWidth < 1024) tableOfContents__Nav.style.maxHeight = 0
      tableOfContents__NavIcon.style.setProperty('--tw-rotate', '0deg');
    }

    if (tableOfContents) {
      tableOfContents.addEventListener('click', () => {
        Alpine.store("toggleButton").toggle();
    
        if (Alpine.store("toggleButton").on) openDropdown()
        else closeDropdown()
      })
    }

    /**
     * 102px is the offset top container on mobile
     * 72px from the sticky button element
     * 30px from the fade element at the bottom of the button
     */
    let offsetTopContainer = 102+96;
    if (window.matchMedia("(min-width: 420px)").matches) {
      offsetTopContainer = 102+78;
    }
    
    if (window.matchMedia("(min-width: 1024px)").matches) {
      /**
       * 40px is the offset top container on larger than 1024px width
       * 32px is the offset top of the sidebar
       * 8px is the padding top of the first menu on the sidebar
       * we don't need the fade element as the desktop it's being hidden
       */
      offsetTopContainer = 40+56;
    }
  
    document.addEventListener("alpine:init", () => {
      // toggle action with Alpine
      Alpine.store("toggleButton", {
        on: false,
        toggle() {
          this.on = !this.on;
        },
      });
    });
  
    Array.prototype.forEach.call(section, function (e) {
      sections[e.id] = e.offsetTop;
    });
  
    menuItems.forEach((menu) => {
      menu.addEventListener("click", (e) => {
        e.preventDefault();
  
        const elm = menu.getAttribute("href");
        console.log(elm)
        const offsetTop =
          document.querySelector(`${elm}`).offsetTop - offsetTopContainer;

        window.scrollTo({
          top: offsetTop,
          left: 0,
          behavior: "smooth",
        });
  
        tableOfContents.click();
      });
    });
  
    window.onscroll = function () {
      let scrollPosition =
        document.documentElement.scrollTop || document.body.scrollTop;
  
      for (i in sections) {
        if (sections[i] <= scrollPosition + offsetTopContainer) {
          menuItems.forEach((menu) => {
            menu.classList.remove(...activeClasses);
          });
  
          document
            .querySelector(`.scrollspy__menu a[href="#${i}"]`)
            .classList.add(...activeClasses);
        }
      }
    };
  }
}
